/**
 * IntelliGems A/B Test: Cart review banner (UpCart + native drawer)
 *
 * Control (A): data-cart-review-banner="false" → Great taste text
 * Variant (B): data-cart-review-banner="true"  → stars + Rated 4.9/5
 *
 * Intelligems inject (Group B):
 *   document.body.setAttribute('data-cart-review-banner', 'true');
 *
 * Dev preview: ?cart_review_banner_test=b
 */
(function () {
  'use strict';

  if (window.__cartReviewBannerABTestInit) return;
  window.__cartReviewBannerABTestInit = true;

  var BODY_ATTR = 'data-cart-review-banner';
  var ROOT_ATTR = 'data-cart-review-banner-root';
  var MARK_ATTR = 'data-cart-review-banner-injected';
  var STYLE_ID = 'cart-review-banner-ab-shadow-style';

  var applying = false;
  var debounceTimer = null;
  var retryTimers = [];
  var cartCache = null;
  var cartFetch = null;
  var hostedBanner = null;

  var SHADOW_CSS =
    '.upcart-internal-announcement.upcart-public-announcement,.upcart-public-announcement,[class*="upcart-public-announcement"]{display:none!important;}' +
    '.cart-review-banner-ab{display:none!important;width:100%;margin:0;padding:1.1rem 1.25rem;box-sizing:border-box;background:#d8eadc;text-align:center;font-family:inherit;}' +
    '.cart-review-banner-ab[data-visible="true"]{display:block!important;}' +
    '.cart-review-banner-ab__variant{display:none!important;align-items:center;justify-content:center;gap:0.55rem;width:100%;}' +
    '.cart-review-banner-ab[data-variant="a"] .cart-review-banner-ab__variant--a{display:flex!important;flex-direction:column;}' +
    '.cart-review-banner-ab[data-variant="b"] .cart-review-banner-ab__variant--b{display:flex!important;flex-direction:row;flex-wrap:nowrap;white-space:nowrap;}' +
    '.cart-review-banner-ab__stars{display:inline-flex;align-items:center;gap:0.05rem;flex-shrink:0;}' +
    '.cart-review-banner-ab__star{display:inline-flex;width:0.95rem;height:0.95rem;}' +
    '.cart-review-banner-ab__star svg{width:100%;height:100%;display:block;}' +
    '.cart-review-banner-ab__text{margin:0;padding:0;font-size:0.8rem;line-height:1.45;font-weight:400;color:#2a2a2a;}' +
    '.cart-review-banner-ab__text--centered{text-align:center;}' +
    '.cart-review-banner-ab__text--rating{white-space:nowrap;text-align:left;}' +
    '.cart-review-banner-ab__text strong{font-weight:700;}' +
    '@media screen and (max-width:640px){.cart-review-banner-ab{padding:0.95rem 1rem;}.cart-review-banner-ab__text{font-size:0.875rem;}.cart-review-banner-ab__star{width:0.85rem;height:0.85rem;}}';

  var STAR_SVG =
    '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" focusable="false">' +
    '<path d="M10 1.5l2.47 5.01 5.53.8-4 3.9.94 5.5L10 14.77l-4.94 2.94.94-5.5-4-3.9 5.53-.8L10 1.5z" fill="#e8a317"/>' +
    '</svg>';

  function isDevVariantB() {
    try {
      return new URLSearchParams(window.location.search).get('cart_review_banner_test') === 'b';
    } catch (e) {
      return false;
    }
  }

  function isTruthy(value) {
    var normalized = String(value || '').trim().toLowerCase();
    return normalized === 'true' || normalized === '1' || normalized === 'on' || normalized === 'yes';
  }

  function isVariantB() {
    if (isDevVariantB()) return true;
    var body = document.body;
    var html = document.documentElement;
    if (!body || !html) return false;
    return isTruthy(body.getAttribute(BODY_ATTR)) || isTruthy(html.getAttribute(BODY_ATTR));
  }

  function cartItemCount() {
    if (cartCache && typeof cartCache.item_count === 'number') return cartCache.item_count;
    return 0;
  }

  function hasItems() {
    return cartItemCount() > 0;
  }

  function getUpcartRoot() {
    if (window.upcartDocumentOrShadowRoot) return window.upcartDocumentOrShadowRoot;

    var host =
      document.querySelector('upcart-cart-drawer') ||
      document.querySelector('#upCart') ||
      document.querySelector('#upcart') ||
      document.querySelector('[data-upcart-cart]') ||
      document.querySelector('[class*="upcart-"]');

    if (!host) return null;
    return host.shadowRoot || host;
  }

  function buildFallbackBanner() {
    var stars = '';
    for (var i = 0; i < 5; i++) {
      stars += '<span class="cart-review-banner-ab__star">' + STAR_SVG + '</span>';
    }

    var banner = document.createElement('div');
    banner.className = 'cart-review-banner-ab';
    banner.setAttribute(ROOT_ATTR, '');
    banner.setAttribute('data-variant', 'a');
    banner.setAttribute('role', 'note');
    banner.setAttribute('aria-label', 'Cart social proof');
    banner.innerHTML =
      '<div class="cart-review-banner-ab__variant cart-review-banner-ab__variant--a">' +
      '<p class="cart-review-banner-ab__text cart-review-banner-ab__text--centered">' +
      'Great taste! Trusted by 200,000+<br>happy homes just like yours.' +
      '</p>' +
      '</div>' +
      '<div class="cart-review-banner-ab__variant cart-review-banner-ab__variant--b" hidden>' +
      '<div class="cart-review-banner-ab__stars" aria-hidden="true">' +
      stars +
      '</div>' +
      '<p class="cart-review-banner-ab__text cart-review-banner-ab__text--rating">' +
      'Rated <strong>4.9/5</strong> by <strong>200,000+</strong> happy customers' +
      '</p>' +
      '</div>';
    return banner;
  }

  function getTemplateBanner() {
    var template = document.getElementById('cart-review-banner-ab-template');
    if (template && template.content) {
      var fromTemplate = template.content.querySelector('[' + ROOT_ATTR + ']');
      if (fromTemplate) return fromTemplate.cloneNode(true);
    }

    var existing = document.querySelector('#sidebar-cart [' + ROOT_ATTR + ']');
    if (existing) return existing.cloneNode(true);

    return buildFallbackBanner();
  }

  function setBannerVariant(banner, variantB) {
    if (!banner) return;
    var key = variantB ? 'b' : 'a';
    banner.setAttribute('data-variant', key);
    banner.setAttribute(
      'aria-label',
      variantB
        ? 'Rated 4.9 out of 5 by 200,000 plus happy customers'
        : 'Great taste! Trusted by 200,000 plus happy homes just like yours.'
    );

    var variantA = banner.querySelector('.cart-review-banner-ab__variant--a');
    var variantBEl = banner.querySelector('.cart-review-banner-ab__variant--b');
    if (variantA) {
      if (variantB) variantA.setAttribute('hidden', '');
      else variantA.removeAttribute('hidden');
    }
    if (variantBEl) {
      if (variantB) variantBEl.removeAttribute('hidden');
      else variantBEl.setAttribute('hidden', '');
    }
  }

  function removeUpcartAnnouncement(root) {
    if (!root || !root.querySelectorAll) return;
    var nodes = root.querySelectorAll(
      '.upcart-internal-announcement.upcart-public-announcement, .upcart-public-announcement, [class*="upcart-public-announcement"]'
    );
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var text = (el.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
      if (
        text.indexOf('great taste') !== -1 ||
        text.indexOf('happy homes just like yours') !== -1 ||
        text.indexOf('trusted by 200,000') !== -1
      ) {
        if (el.parentNode) el.parentNode.removeChild(el);
      }
    }
  }

  function ensureShadowStyle(root) {
    if (!root || !root.querySelector) return;
    var existing = root.querySelector('#' + STYLE_ID);
    if (existing) {
      existing.textContent = SHADOW_CSS;
      return;
    }
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = SHADOW_CSS;
    if (root.firstChild) root.insertBefore(style, root.firstChild);
    else root.appendChild(style);
  }

  function findUpcartInsertPoint(root) {
    var announcement =
      root.querySelector('.upcart-public-announcement') ||
      root.querySelector('.upcart-announcement') ||
      root.querySelector('[class*="upcart-public-announcement"]') ||
      root.querySelector('[class*="announcement"]');

    if (announcement && announcement.parentNode) {
      return { parent: announcement.parentNode, before: announcement };
    }

    var header =
      root.querySelector('.upcart-public-header') ||
      root.querySelector('.upcart-header') ||
      root.querySelector('[class*="upcart-public-header"]') ||
      root.querySelector('[class*="CartHeader"]') ||
      root.querySelector('header');

    if (header && header.parentNode) {
      return { parent: header.parentNode, after: header };
    }

    var body =
      root.querySelector('.upcart-public-cart-body') ||
      root.querySelector('[class*="upcart-public-"]') ||
      root.querySelector('[class*="CartBody"]');

    if (body && body.parentNode) {
      return { parent: body.parentNode, before: body };
    }

    return { parent: root, before: root.firstChild || null };
  }

  function insertBanner(point, banner) {
    if (!point || !point.parent) return;
    if (point.before && point.before.parentNode === point.parent) {
      point.parent.insertBefore(banner, point.before);
      return;
    }
    if (point.after && point.after.parentNode === point.parent) {
      if (point.after.nextSibling) point.parent.insertBefore(banner, point.after.nextSibling);
      else point.parent.appendChild(banner);
      return;
    }
    if (point.parent.firstChild) point.parent.insertBefore(banner, point.parent.firstChild);
    else point.parent.appendChild(banner);
  }

  function syncNativeBanners(visible, variantB) {
    var banners = document.querySelectorAll('#sidebar-cart [' + ROOT_ATTR + ']');
    for (var i = 0; i < banners.length; i++) {
      banners[i].setAttribute('data-visible', visible ? 'true' : 'false');
      setBannerVariant(banners[i], variantB);
      banners[i].style.display = visible ? 'block' : 'none';
    }

    var drawer = document.getElementById('sidebar-cart');
    if (drawer) {
      drawer.setAttribute('data-item-count', String(cartItemCount()));
    }
  }

  function removeHostedBanner() {
    if (hostedBanner && hostedBanner.parentNode) {
      hostedBanner.parentNode.removeChild(hostedBanner);
    }
  }

  function syncUpcartBanner(variantB) {
    if (!hasItems()) {
      removeHostedBanner();
      return;
    }

    var root = getUpcartRoot();
    if (!root) return;

    ensureShadowStyle(root);
    removeUpcartAnnouncement(root);

    if (!hostedBanner) {
      hostedBanner = getTemplateBanner();
      hostedBanner.setAttribute(MARK_ATTR, 'true');
    }

    hostedBanner.setAttribute('data-visible', 'true');
    setBannerVariant(hostedBanner, variantB);
    hostedBanner.style.cssText =
      'display:block!important;width:100%;box-sizing:border-box;background:#d8eadc;text-align:center;position:relative;z-index:5;';

    if (!hostedBanner.isConnected || !root.contains(hostedBanner)) {
      insertBanner(findUpcartInsertPoint(root), hostedBanner);
    }
  }

  function applyVariant() {
    if (applying) return;
    applying = true;

    try {
      var variantB = isVariantB();
      var visible = hasItems();
      document.documentElement.classList.toggle('cart-review-banner-b', variantB);
      document.documentElement.classList.add('cart-review-banner-ready');

      syncNativeBanners(visible, variantB);
      var upcartRoot = getUpcartRoot();
      if (upcartRoot) {
        ensureShadowStyle(upcartRoot);
        removeUpcartAnnouncement(upcartRoot);
      }
      if (visible) syncUpcartBanner(variantB);
      else removeHostedBanner();
    } finally {
      applying = false;
    }
  }

  function scheduleApply() {
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(applyVariant, 40);
  }

  function retryAfterCartChange() {
    var delays = [0, 80, 200, 400, 700, 1200, 2000, 3200];
    for (var i = 0; i < retryTimers.length; i++) clearTimeout(retryTimers[i]);
    retryTimers = [];
    for (var d = 0; d < delays.length; d++) {
      retryTimers.push(setTimeout(refreshCart, delays[d]));
    }
  }

  function fetchCartThenApply() {
    if (cartFetch) return cartFetch;

    var cartUrl = (window.routes && window.routes.cartUrl ? window.routes.cartUrl : '/cart') + '.js';
    cartFetch = fetch(cartUrl)
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        cartCache = cart || { item_count: 0 };
        applyVariant();
      })
      .catch(function () {
        applyVariant();
      })
      .then(function () {
        cartFetch = null;
      });

    return cartFetch;
  }

  function refreshCart() {
    cartFetch = null;
    fetchCartThenApply();
  }

  function isCartUrl(url) {
    return /\/cart\/(add|change|update|clear)/i.test(String(url || ''));
  }

  function subscribeUpcart() {
    var subs = [
      'upcartSubscribeCartLoaded',
      'upcartSubscribeAddedToCart',
      'upcartSubscribeItemRemoved',
      'upcartSubscribeCartOpened',
      'upcartSubscribeCartClosed',
    ];

    for (var i = 0; i < subs.length; i++) {
      if (typeof window[subs[i]] === 'function') {
        try {
          window[subs[i]](function () {
            retryAfterCartChange();
          });
        } catch (e) {}
      }
    }
  }

  function init() {
    if (isDevVariantB()) {
      if (document.documentElement.getAttribute(BODY_ATTR) !== 'true') {
        document.documentElement.setAttribute(BODY_ATTR, 'true');
      }
      if (document.body && document.body.getAttribute(BODY_ATTR) !== 'true') {
        document.body.setAttribute(BODY_ATTR, 'true');
      }
    }

    fetchCartThenApply();
    subscribeUpcart();

    var tries = 0;
    var waitForUpcart = setInterval(function () {
      tries += 1;
      subscribeUpcart();
      if (getUpcartRoot()) scheduleApply();
      if (tries > 40) clearInterval(waitForUpcart);
    }, 250);

    if (!document.body) return;

    new MutationObserver(function (mutations) {
      if (applying) return;

      var shouldApply = false;

      for (var i = 0; i < mutations.length; i++) {
        var mutation = mutations[i];

        if (mutation.type === 'attributes') {
          shouldApply = true;
          break;
        }

        if (mutation.type === 'childList' && hasItems()) {
          if (!hostedBanner || !hostedBanner.isConnected) {
            shouldApply = true;
            break;
          }
        }
      }

      if (shouldApply) scheduleApply();
    }).observe(document.body, {
      attributes: true,
      attributeFilter: [BODY_ATTR, 'data-gem-variant', 'data-gem-test-active', 'class'],
      childList: true,
      subtree: true,
    });

    document.addEventListener('gem:variant:changed', applyVariant);
    document.addEventListener('cart:refresh', retryAfterCartChange);
    document.addEventListener('product:added', retryAfterCartChange);
    document.addEventListener('upcart:open', retryAfterCartChange);
    document.addEventListener('upcart:refresh', retryAfterCartChange);

    ['upcart:opened', 'upcart:updated', 'cart:updated', 'cart:change', 'cart:added'].forEach(
      function (name) {
        document.addEventListener(name, retryAfterCartChange);
      }
    );

    document.addEventListener(
      'click',
      function (event) {
        var trigger =
          event.target.closest &&
          event.target.closest(
            '[name="add"], [data-action="add-to-cart"], .ProductForm__AddToCart, button[type="submit"][name="add"], [href*="/cart/add"]'
          );
        if (trigger) retryAfterCartChange();
      },
      true
    );

    if (window.fetch) {
      var nativeFetch = window.fetch;
      window.fetch = function () {
        var input = arguments[0];
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        var request = nativeFetch.apply(this, arguments);
        if (isCartUrl(url)) {
          request
            .then(function () {
              retryAfterCartChange();
            })
            .catch(function () {});
        }
        return request;
      };
    }

    var nativeOpen = XMLHttpRequest.prototype.open;
    var nativeSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.__crbCartUrl = url;
      return nativeOpen.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function () {
      if (isCartUrl(this.__crbCartUrl)) {
        this.addEventListener('loadend', function () {
          retryAfterCartChange();
        });
      }
      return nativeSend.apply(this, arguments);
    };
  }

  window.CartReviewBannerAB = {
    enable: function () {
      if (!document.body) return;
      document.body.setAttribute(BODY_ATTR, 'true');
      retryAfterCartChange();
    },
    disable: function () {
      if (!document.body) return;
      document.body.setAttribute(BODY_ATTR, 'false');
      scheduleApply();
    },
    isEnabled: isVariantB,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
